module.exports = __webpack_public_path__ + "4241f2e7.png";